// @flow
import {
  GetEmployeeDetails,
  GetEmployeeDetailsSuccess,
  GetEmployeeDetailsError,
} from "@modules/reporting/constants/actions";
import type { EmployeeDetailsState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: EmployeeDetailsState = {
  error: null,
  requestsInProgress: 0,
  details: null,
};

export const setLoading = (state: EmployeeDetailsState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetEmployeeDetailsSuccess = (state: EmployeeDetailsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    details: payload,
  };
};

export const onGetEmployeeDetailsError = (state: EmployeeDetailsState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export default (
  state: EmployeeDetailsState = initialState,
  action: Object,
): EmployeeDetailsState => {
  let act = {
    [GetEmployeeDetails]: setLoading,
    [GetEmployeeDetailsSuccess]: onGetEmployeeDetailsSuccess,
    [GetEmployeeDetailsError]: onGetEmployeeDetailsError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
